<template>
  <div>
    <b-modal size="lg" id="modal-import" title="Import" class="theme-modal">
      <div>
        <h4 class="col-form-label" for="message-text">
          Field Require :
          <span style="float: right"
            ><b-badge href="#" @click="downloadTemplate" pill variant="primary"
              ><span>Download Template</span></b-badge
            ></span
          >
        </h4>
      </div>
      <div class="col">
        <div class="d-inline p-1" v-for="n in data.importField" :key="n.key">
          <b-badge pill variant="light" v-if="n.isFind == null">{{
            n.key
          }}</b-badge>
          <b-badge pill variant="danger" v-if="n.isFind == false">{{
            n.key
          }}</b-badge>
          <b-badge pill variant="success" v-if="n.isFind == true">{{
            n.key
          }}</b-badge>
        </div>
      </div>
      <h4 class="col-form-label" for="recipient-name">Upload File :</h4>
      <div class="col">
        <div class="row theme-form">
          <div class="col">
            <div class="form-group">
              <input
                class="form-control"
                type="file"
                :disabled="showStatus == 'import loading'"
                accept=".csv"
                @change="onFileChange"
              />
            </div>
          </div>
        </div>
      </div>
      <label>
          <span class="text-danger">* กรุณาเปลี่ยนอักขระ "," (comma) ในข้อความเป็น "{{commaCode}}"  เพื่อความถูกต้องในการ import ข้อมูล</span> 
      </label>
      <div class="col" v-if="itemFail.length > 0">
        <p>
          fail
          <span class="text-danger"> {{ this.itemFail.length }}</span>
          item. click <span class="text-info"> <a href="javascript:void(0)" @click="downloadItemFail">here</a></span> to download
          the file
        </p>
      </div>
      <div class="col" v-if="showStatus == 'import detail'">
        <vue-good-table
          :columns="columns"
          :rows="rows"
          :pagination-options="{
            enabled: true,
            mode: 'pages',
          }"
        >
        </vue-good-table>
      </div>
      <div class="loader-box" v-if="showStatus == 'import loading'">
        <div class="loader-2"></div>
      </div>
      <template #modal-footer>
        <b-button variant="primary" v-if="isImport" @click="onImport"
          ><i class="icofont icofont-download-alt"></i> Import</b-button
        >
        <b-button variant="primary" disabled v-else
          ><i class="icofont icofont-download-alt"></i> Import</b-button
        >
      </template>
    </b-modal>
  </div>
</template>
<script>
  import Vue from 'vue';
  import HeaderSetting from './header-setting.vue';
  import VueGoodTablePlugin from 'vue-good-table';
  import 'vue-good-table/dist/vue-good-table.css';
  Vue.use(VueGoodTablePlugin);
  import { requestService } from './../../_services';
  export default {
    components: {
      HeaderSetting,
      
    },
    name: 'Import-Setting',
    props: {
      data: Object,
    },
    data() {
      return {
        headTopic: ['Field Import'],
        isImport: false,
        file: null,
        columns: [],
        rows: [],
        showStatus: '',
        isFail: false,
        itemFail: [],
        textFail:"",
        commaCode:"&comma;"
      };
    },
    async mounted() {},
    methods: {
      downloadItemFail(){
        var csvString = this.textFail;
        var universalBOM = "\uFEFF";
        var a = window.document.createElement('a');
        a.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM+csvString));
        a.setAttribute('download', "item_fail.csv");
        window.document.body.appendChild(a);
        a.click();
        // return requestService.GetFetch(url).then((response) => {
        //     if (response.status == 200) {
        //         response.text().then((text) => {
        //             var csvString = text;
        //             var universalBOM = "\uFEFF";
        //             var a = window.document.createElement('a');
        //             a.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM+csvString));
        //             a.setAttribute('download', "item_fail.csv");
        //             window.document.body.appendChild(a);
        //             a.click();
        //         });
        //     }
        // });
      },
      async onImport() {
        this.showStatus = 'import loading';
        this.isImport = false;
        requestService.PostFetch(this.data.module,this.data.importUrl, this.rows).then((response) => {
              if (response.status == 200) {
                  response.text().then((text) => {
                      let self = this;
                      if(text !=""){
                          self.textFail=text
                          const arr =text.split('\n');
                          arr.forEach((element,index) => {
                              if(element !="" && index >0){
                                self.itemFail.push(element)
                              }
                          });
                          self.rows = [];
                          self.columns = [];
                          self.isImport = false;
                          self.showStatus = '';
                          self.data.importField.forEach((element, index) => {
                              element.isFind = null;
                          });
                          self.$emit('reload');
                          if(self.itemFail.length ==0){
                              self.$swal.fire({
                                  icon: 'success',
                                  title: 'Import Success',
                                  showConfirmButton: false,
                                  timer: 1500,
                              });
                              self.setDefault();
                          }
                      }
                  });
              }
          }).catch((err) => {
              this.$swal.fire({
                  icon: 'error',
                  title: 'Try Again',
                  text: err,
              });
          });
      },
      setDefault() {
        this.itemFail = [];
        this.rows = [];
        this.columns = [];
        this.isImport = false;
        this.showStatus = '';
        this.data.importField.forEach((element, index) => {
          element.isFind = null;
        });
      },
      async downloadTemplate() {
        let str = '';
        this.data.importField.forEach((element, index) => {
          if (str != '') {
            str += '&';
          }
          str += element.key + '=' + element.key;
        });
        var url = '/api/template/download?' + str;
        return requestService.GetFetch(this.data.module,url).then((response) => {
            if (response.status == 200) {
                response.text().then((text) => {
                    var csvString = text;
                    var universalBOM = "\uFEFF";
                    var a = window.document.createElement('a');
                    a.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM+csvString));
                    a.setAttribute('download', "template.csv");
                    window.document.body.appendChild(a);
                    a.click();
                });
            }
        });

        // var url = '/api/template/download?' + str;
        // const res = await requestService.GetFetch(url);
        // const blob = await res.blob();
        // const file = window.URL.createObjectURL(blob);
        // window.location.assign(file);
      },
      // onImport() {
      //     this.showItem=false
      //     this.isLoading=true
      //     this.isImport=false
      //     this.$emit('import',this.rows);
      // },
      onFileChange(e) {
          this.setDefault();
          this.data.importField.forEach((element, index) => {
            element.isFind = null;
          });
          var files = e.target.files || e.dataTransfer.files;
          if (!files.length) return;
          this.createInput(files[0]);
          this.file = e.target.files[0];
      },
      createInput(file) {
          this.showStatus = 'import detail';
          var reader = new FileReader();
          var self = this;
          var array = [];
          reader.onload = (e) => {
              var fileinput = reader.result;
              self.csvJSON(fileinput)
              array = fileinput.split('\n');
              if (array.length > 0) {
                  var hearderCsv = array[0];
                  hearderCsv = hearderCsv.replace('\r', '');
                  hearderCsv = hearderCsv.split(',');
                  self.data.importField.forEach((element, index) => {
                    if (hearderCsv.includes(element.key)) {
                        self.data.importField[index].isFind = true;
                        self.isImport = true;
                    } else {
                        self.data.importField[index].isFind = false;
                        self.isImport = false;
                    }
                  });
              }
          };
          reader.readAsText(file);
      },
      convertCsvToJson(csv) {
        const array = csv.split('\n');
        /* Store the converted result into an array */
        const csvToJsonResult = [];
        /* Store the CSV column headers into seprate variable */
        const headers = array[0].split(',');
        headers.forEach((element, index) => {
          headers[index] = headers[index].replace('\r', '');
          var obj = {
            label: headers[index],
            field: headers[index],
            hidden: false,
            visible: true,
            topic: 'Field Import',
          };
          this.columns.push(obj);
        });
        /* Iterate over the remaning data rows */
        for (let i = 1; i <= array.length - 1; i++) {
          /* Empty object to store result in key value pair */
          const jsonObject = {};
          /* Store the current array element */
          const currentArrayString = array[i].replace('\r', '');
          let string = '';

          let quoteFlag = 0;
          for (let character of currentArrayString) {
            if (character === '"' && quoteFlag === 0) {
              quoteFlag = 1;
            } else if (character === '"' && quoteFlag == 1) quoteFlag = 0;
            if (character === ',' && quoteFlag === 0) character = '|';
            if (character !== '"') string += character;
          }
          let jsonProperties = string.split('|');
          for (let j in headers) {
            if (jsonProperties[j].includes(',')) {
              jsonObject[headers[j]] = jsonProperties[j]
                .split(',')
                .map((item) => item.trim());
            } else jsonObject[headers[j]] = jsonProperties[j];
          }
          /* Push the genearted JSON object to resultant array */
          csvToJsonResult.push(jsonObject);
        }
        /* Convert the final array to JSON */
        const json = JSON.stringify(csvToJsonResult);
        // this.rows = csvToJsonResult;
      },
      csvJSON(csv){
          var lines=csv.split("\n");
          var result = [];
          var headers=lines[0].replace('\r', '').split(",");
          headers.forEach((element, index) => {
          headers[index] = headers[index].replace('\r', '');
          var obj = {
              label: headers[index],
              field: headers[index],
              hidden: false,
              visible: true,
              topic: 'Field Import',
            };
            this.columns.push(obj);
          });
          for(var i=1;i<lines.length;i++){
              var obj = {};
              var currentline=lines[i].replace('\r', '').split(",");
              for(var j=0;j<headers.length;j++){
                  obj[headers[j]] = currentline[j];
              }
              result.push(obj);
          }
          result.forEach((object,i) => {
              Object.keys(object).forEach((key) => {
                  if(typeof object[key]  !== "undefined"){
                      if(object[key].replaceAll(' ', '')  == ''){
                          delete object[key]
                      }
                  }else{
                      delete object[key]
                  }
              })
          })
          this.rows = result.filter((object) =>{
              if(Object.keys(object).length > 0){
                  return object
              }
          });
      }
    },
  };
</script>
